var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-drug-check-status"},[(_vm.loading)?_c('div',{staticClass:"ai-drug-check-status-pill"},[_c('div',{staticClass:"loading"}),_c('span',[_vm._v("Checagem de medicamentos...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }